export type ShotLoad = (typeof ShotLoad)[keyof typeof ShotLoad];

export const ShotLoad = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
} as const;

export function isShotLoad(arg: unknown): arg is ShotLoad {
  return Object.values(ShotLoad).includes(arg as ShotLoad);
}

export function isShotLoadArray(arg: unknown): arg is ShotLoad[] {
  return Array.isArray(arg) && arg.every(isShotLoad);
}
